import {
  Autocomplete, Grid, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, TextField, Typography,Box,
} from '@mui/material'
import axios from 'axios'
import _ from 'lodash'
import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers'
import { useStyle } from '../../billing/style'
import dayjs from 'dayjs'
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from 'moment'
import { Helmet } from 'react-helmet-async'

const OtBranchCategoryWise = () => {
  const dispatch = useDispatch()
  const classes = useStyle()
  const [data, setData] = useState([])
  const [lastYearData, setLastYearData] = useState([])
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [catData, setCatData] = useState([])
  const [subData, setSubData] = useState([])
  const [headData, setHeadData] = useState([])
  const [typeData, setTypeData] = useState([])
  const [supplier, setSupplier] = useState([]);
  const [outletName, setOutletName] = useState([])
  const [lastYearOutletName, setLastYearOutletName] = useState([])
const [options, setOptions] = useState({
  customer: null,
  head: null,
  type: null,
  category: null,
  subCategory: null,
  fromDate: moment().startOf('month').format('YYYY-MM-DD'),
  toDate: moment().format('YYYY-MM-DD')
})

  function handleChange(value, name) {
    if (name === 'fromDate' || name === 'toDate') {
      const formattedDate = dayjs(value).format('YYYY-MM-DD');
      setOptions(prev => ({ ...prev, [name]: formattedDate }));
    } else {
      setOptions(prev => ({ ...prev, [name]: value }));
    }
  }

  // Fetch data for the CURRENT date range
  function getItemData() {
    const allItems = {
      from_date: moment(options.fromDate).format('YYYY-MM-DD'),
      to_date: moment(options.toDate).format('YYYY-MM-DD'),
      customer: options.customer === null ? 0 : options.customer.id,
      category: options.category === null ? 0 : options.category.id,
      subcategory: options.subCategory === null ? 0 : options.subCategory.id,
      type: options.type === null ? 0 : options.type.id,
      head: options.head === null ? 0 : options.head.id
    }
    axios.post(`/v1/reports/outlet_sales/groupwise/alloutlets`, allItems)
      .then(res => {
        setOutletName(res.data[0].outlets_names_header)
        const responseData = res.data.slice(1)
        setData(responseData)
      })
      .catch(err => {
        if (err.response.data.errors[0].message === "INTERNAL_SERVER_ERROR") {
          dispatch(setSnackbar(true, 'error', "Data not found"))
        } else {
          dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
        }
      })
  }

  // Fetch data for LAST YEAR's date range (same filters, but date shifted back 1 year)
  function getLastYearItemData() {
    const fromDate = moment(options.fromDate).subtract(1, 'years').format('YYYY-MM-DD');
    const toDate = moment(options.toDate).subtract(1, 'years').format('YYYY-MM-DD');
    const allItems = {
      from_date: fromDate,
      to_date: toDate,
      customer: options.customer === null ? 0 : options.customer.id,
      category: options.category === null ? 0 : options.category.id,
      subcategory: options.subCategory === null ? 0 : options.subCategory.id,
      type: options.type === null ? 0 : options.type.id,
      head: options.head === null ? 0 : options.head.id
    }
    axios.post(`/v1/reports/outlet_sales/groupwise/alloutlets`, allItems)
      .then(res => {
        setLastYearOutletName(res.data[0].outlets_names_header)
        const responseData = res.data.slice(1)
        setLastYearData(responseData)
      })
      .catch(() => {
        setLastYearOutletName([])
        setLastYearData([])
      })
  }

  // Fetching dropdown/filter data
  function getHead() {
    axios.get('/v1/Head').then(res => setHeadData(res.data))
      .catch(err => dispatch(setSnackbar(true, 'error', err.response.errors[0].message)))
  }
  function getTypeData() {
    axios.get('/v1/typedesign').then(res => setTypeData(res.data))
      .catch(err => dispatch(setSnackbar(true, 'error', err.response.errors[0].message)))
  }
  function getCategory() {
    axios.get('/v1/categories').then(res => {
      const active = _.filter(res.data, val => val.is_active)
      setCatData(active)
    }).catch(err => {
      dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
    })
  }
  function getSubCategory() {
    axios.get('/v1/subcategories').then(res => setSubData(res.data))
      .catch(err => dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message)))
  }
  function getSupplierData() {
    axios.get("/v1/outlet/list/1").then(res => setSupplier(res.data))
      .catch(err => dispatch(setSnackbar(true, "error", err.response.data.errors[0].message)))
  }

  useEffect(() => {
    getCategory()
    getSubCategory()
    getHead()
    getTypeData()
    getSupplierData()
  }, [])

  useEffect(() => {
    getItemData()
    getLastYearItemData()
  }, [rowsPerPage, page, options])

  return (
 <Fragment>
<Box
  sx={{
    display: "flex",
    alignItems: "left",
    justifyContent: "left",
    mt: 1,
    mb: 3,
    p: 1.8,
    backgroundColor: "#ffffff",
    borderRadius: 2,
  }}
>
  <Typography
    variant="h6"
    sx={{
      fontWeight: 700,
      color:"black",
      letterSpacing: 0.8,
      textTransform: "uppercase",
    }}
  >
    Branch Category Wise Sales Report
  </Typography>
</Box>
      <Grid container spacing={2} className='p-2 pt-2'>
        <Grid item md={3}>
          <Autocomplete
            size="small"
            options={supplier}
            onChange={(e, value) => handleChange(value, 'customer')}
            getOptionLabel={option => option.fullname}
            renderInput={(params) => <TextField {...params} label="Select Outlet" />}
          />
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(options.fromDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label: 'From',
                  style: { width: '100%' },
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(options.toDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label: 'To',
                  style: { width: '100%' }
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <Autocomplete
            size='small'
            value={options.head}
            options={headData}
            getOptionLabel={option => option.cateogory_name}
            onChange={(e, value) => handleChange(value, 'head')}
            renderInput={(params) => (
              <TextField {...params} label='Head' />
            )}
          />
        </Grid>
        <Grid item md={3}>
          <Autocomplete
            size='small'
            options={typeData}
            value={options.type}
            getOptionLabel={option => option.type_name}
            onChange={(e, value) => handleChange(value, 'type')}
            renderInput={(params) => (
              <TextField {...params} label='Type Design' />
            )}
          />
        </Grid>
        <Grid item md={3}>
          <Autocomplete
            size='small'
            value={options.category}
            options={catData}
            getOptionLabel={option => option.category_name}
            onChange={(e, value) => handleChange(value, 'category')}
            renderInput={(params) => (
              <TextField {...params} label='Category' />
            )}
          />
        </Grid>
        <Grid item md={3}>
          <Autocomplete
            size='small'
            options={subData}
            value={options.subCategory}
            getOptionLabel={option => option.subcategory_name}
            onChange={(e, value) => handleChange(value, 'subCategory')}
            renderInput={(params) => (
              <TextField {...params} label='Sub Category' />
            )}
          />
        </Grid>
      </Grid>

      {/* Current Period Table */}
     <Typography
    variant="subtitle1"
     sx={{
    mt: 3,
    mb: 1,
    fontWeight: "bold",
    color: "#4A148C", // purple shade
    backgroundColor: "#F3E5F5", // light purple bg
    p: 1.2,
    borderRadius: 1,
  }}
>
  Branch Category Wise Current Year
</Typography>
      <TableContainer className={classes.tblRoot} sx={{ maxHeight: 700 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead className={classes.tblHeader} sx={{ position: "sticky", top: 0, }}>
            <TableRow className={classes.tablrow}>
              <TableCell rowSpan={2} sx={{ minWidth: 70 }}>S.no</TableCell>
              <TableCell rowSpan={2} sx={{ minWidth: 150 }}>Head</TableCell>
              <TableCell rowSpan={2} sx={{ minWidth: 150 }}>Type</TableCell>
              <TableCell rowSpan={2} sx={{ minWidth: 150 }}>Category</TableCell>
              <TableCell rowSpan={2} sx={{ minWidth: 150 }}>Subcategory</TableCell>
              <TableCell rowSpan={2} sx={{ minWidth: 70 }}>Total Qty</TableCell>
              <TableCell rowSpan={2} sx={{ minWidth: 130 }}>Total Amount</TableCell>
              {_.map(outletName, (val, idx) => (
                <React.Fragment key={idx}>
                  <TableCell colSpan={2} sx={{ minWidth: 180 }}>{val.outlet_name || "-"}</TableCell>
                </React.Fragment>
              ))}
            </TableRow>
            <TableRow className={classes.tablrow}>
              {_.map(outletName, (val, idx) => (
                <React.Fragment key={idx}>
                  <TableCell>Quantity</TableCell>
                  <TableCell>Amount</TableCell>
                </React.Fragment>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {_.map(data, (value, idx) => (
              <TableRow key={idx} className={classes.tablrow}>
                <TableCell>{idx + 1}</TableCell>
                <TableCell>{value.head_name || "-"}</TableCell>
                <TableCell>{value.type_name || "-"}</TableCell>
                <TableCell>{value.category_name || "-"}</TableCell>
                <TableCell>{value.subcategory_name || "-"}</TableCell>
                <TableCell>{value.total_qty || "-"}</TableCell>
                <TableCell sx={{ textAlign: "right !important", fontWeight: "bold" }}>{parseFloat(value.total_amount).toFixed(0) || "-"}</TableCell>
                {outletName.map((outlet, index) => {
                  const outletDetail = value.outlet_details.find(detail => detail.outlet_code === outlet.outlet_code);
                  return (
                    <React.Fragment key={index}>
                      <TableCell>{outletDetail ? outletDetail.total_qty || "-" : "-"}</TableCell>
                      <TableCell sx={{ textAlign: "right !important", fontWeight: "bold" }}>
                        {outletDetail ? parseFloat(outletDetail.total_amount).toFixed(0) || "-" : "-"}
                      </TableCell>
                    </React.Fragment>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Last Year Period Table */}
      <Typography
       variant="subtitle1"
       sx={{
       mt: 4,
       mb: 1,
       fontWeight: "bold",
       color: "#1A237E", // deep indigo
       backgroundColor: "#E8EAF6", // light indigo bg
       p: 1.2,
       borderRadius: 1,
  }}
>
  Branch Category Wise Previous Year
</Typography>
      <TableContainer className={classes.tblRoot} sx={{ maxHeight: 700 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead className={classes.tblHeader} sx={{ position: "sticky", top: 0, }}>
            <TableRow className={classes.tablrow}>
              <TableCell rowSpan={2} sx={{ minWidth: 70 }}>S.no</TableCell>
              <TableCell rowSpan={2} sx={{ minWidth: 150 }}>Head</TableCell>
              <TableCell rowSpan={2} sx={{ minWidth: 150 }}>Type</TableCell>
              <TableCell rowSpan={2} sx={{ minWidth: 150 }}>Category</TableCell>
              <TableCell rowSpan={2} sx={{ minWidth: 150 }}>Subcategory</TableCell>
              <TableCell rowSpan={2} sx={{ minWidth: 70 }}>Total Qty</TableCell>
              <TableCell rowSpan={2} sx={{ minWidth: 130 }}>Total Amount</TableCell>
              {_.map(lastYearOutletName, (val, idx) => (
                <React.Fragment key={idx}>
                  <TableCell colSpan={2} sx={{ minWidth: 180 }}>{val.outlet_name || "-"}</TableCell>
                </React.Fragment>
              ))}
            </TableRow>
            <TableRow className={classes.tablrow}>
              {_.map(lastYearOutletName, (val, idx) => (
                <React.Fragment key={idx}>
                  <TableCell>Quantity</TableCell>
                  <TableCell>Amount</TableCell>
                </React.Fragment>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {_.map(lastYearData, (value, idx) => (
              <TableRow key={idx} className={classes.tablrow}>
                <TableCell>{idx + 1}</TableCell>
                <TableCell>{value.head_name || "-"}</TableCell>
                <TableCell>{value.type_name || "-"}</TableCell>
                <TableCell>{value.category_name || "-"}</TableCell>
                <TableCell>{value.subcategory_name || "-"}</TableCell>
                <TableCell>{value.total_qty || "-"}</TableCell>
                <TableCell sx={{ textAlign: "right !important", fontWeight: "bold" }}>{parseFloat(value.total_amount).toFixed(0) || "-"}</TableCell>
                {lastYearOutletName.map((outlet, index) => {
                  const outletDetail = value.outlet_details.find(detail => detail.outlet_code === outlet.outlet_code);
                  return (
                    <React.Fragment key={index}>
                      <TableCell>{outletDetail ? outletDetail.total_qty || "-" : "-"}</TableCell>
                      <TableCell sx={{ textAlign: "right !important", fontWeight: "bold" }}>
                        {outletDetail ? parseFloat(outletDetail.total_amount).toFixed(0) || "-" : "-"}
                      </TableCell>
                    </React.Fragment>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Fragment>
  )
}

export default OtBranchCategoryWise
